import Grid from "@mui/material/Grid";
import Dialog from "../Dialog/Dialog";
import lang from "../../constants/lang";
import { styles } from "./styles";
import { Lottie } from "@alfonmga/react-lottie-light-ts";
import loaderAnimation from "../../animations/loader.json";
import useStyles from "@hooks/useStyle";
import { Typography } from "@mv-components/index";

const defaultOptions = {
	loop: true,
	autoplay: true,
	animationData: loaderAnimation,
	rendererSettings: {
		preserveAspectRatio: "xMidYMid slice",
	},
};

export const Loader = (props: any) => {
	const { showLoader } = props;
	const { classes } = useStyles(styles) as any;

	return (
		<Dialog
			open={showLoader}
			blocking={props.blocking}
			noTitle
			disableBackdropClick={true}
			actionBtn={false}
			contentClassName={classes.dialogRoot}
			PaperProps={{ className: classes.loadingPopup }}
		>
			<Grid container alignItems="center" className={classes.container}>
				<Grid item className={classes.logoWrapper}>
					<Lottie config={defaultOptions} />
				</Grid>
				<Typography variant="h6" component="h1" align="center" className={classes.title}>
					{props.loaderText ? props.loaderText : lang.PLEASE_WAIT}
				</Typography>
			</Grid>
		</Dialog>
	);
};
export default Loader;
